import { createSlice } from "@reduxjs/toolkit";

interface ChatState {
  chatData: any;
}

const initialState: ChatState = {
  chatData: null,
};

export const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {},
});

export default chatSlice.reducer;
